<template>
  <a-spin v-if="loading" class="global-loading" dot :tip="tip"> </a-spin>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useAppStore } from '@/store';

  const appStore = useAppStore();

  const loading = computed(() => appStore.loading);
  const tip = computed(() => appStore.loadingTip);
</script>

<style lang="less">
  .global-loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    text-align: center;
    background-color: var(--color-spin-layer-bg);
    transition: opacity 0.1s cubic-bezier(0, 0, 1, 1);
    user-select: none;
    .arco-spin-icon {
      margin-top: 25%;
    }
    .arco-spin-tip {
      margin-top: 10px;
    }
  }
</style>
